/* Hover-preview the swatch display name in the heading row */
(function () {
  function init(root) {
    var label = root.querySelector('[data-meta-swatch-label]');
    if (!label) return;

    var initial = label.textContent;
    var swatches = root.querySelectorAll('[data-meta-swatch]');

    swatches.forEach(function (s) {
      s.addEventListener('mouseenter', function () {
        var name = s.getAttribute('data-display-name');
        if (name) label.textContent = name;
      });
      s.addEventListener('focus', function () {
        var name = s.getAttribute('data-display-name');
        if (name) label.textContent = name;
      });
    });

    root.addEventListener('mouseleave', function () {
      label.textContent = initial;
    });
  }

  function boot() {
    document.querySelectorAll('[data-meta-swatches]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
